import React from "react";
import { DollarSign, Euro, PoundSterling, IndianRupee, Coins } from "lucide-react";
import { getCurrencyIconName } from "../../utils/utils";

interface CurrencyIconProps {
  currency?: string;
  className?: string;
}

const iconMap = {
  DollarSign,
  Euro,
  PoundSterling,
  IndianRupee,
  Coins,
};

/**
 * CurrencyIcon Component
 * Dynamically renders the appropriate currency icon based on the currency code
 * @param currency - ISO 4217 currency code (e.g., 'USD', 'EUR', 'GBP')
 * @param className - Tailwind CSS classes for styling
 */
const CurrencyIcon: React.FC<CurrencyIconProps> = ({ currency = "USD", className }) => {
  const iconName = getCurrencyIconName(currency);
  const Icon = iconMap[iconName];
  return <Icon className={className} />;
};

export default CurrencyIcon;
